import { render, staticRenderFns } from "./AdvDioptraProductTabMeta.vue?vue&type=template&id=4ce95218"
import script from "./AdvDioptraProductTabMeta.vue?vue&type=script&lang=js"
export * from "./AdvDioptraProductTabMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports